<template>
  <button class="stepper-control__btn--more" @click="onClick">
    <MoreHorizontal class="stepper-control__btn-icon--more" />
  </button>
</template>
<script>
import MoreHorizontal from '../../atoms/svg_icons/MoreHorizontal.vue'

export default {
  components: {
    MoreHorizontal
  },
  methods: {
    onClick() {
      this.$emit('click-stepper-control-btn-more')
    }
  }
}
</script>
<style lang="scss" scoped>
.stepper-control {
  &__btn--more {
    width: 36px;
    height: 36px;
    background-color: $gray-2;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__btn-icon--more {
    fill: $black;
  }
}
</style>
